import {
  MaxWidthContainer,
  StyledContainer,
} from '@/shared/ui/PageContainer/styles';

export const PageContainer = ({ children }: { children?: React.ReactNode }) => {
  return (
    <MaxWidthContainer>
      <StyledContainer>{children}</StyledContainer>
    </MaxWidthContainer>
  );
};
